__turbopack_context__.v({
  "content-blocks-renderer": "ContentBlocksRenderer-module-scss-module__Kdva6W__content-blocks-renderer",
  "content-blocks-renderer__item": "ContentBlocksRenderer-module-scss-module__Kdva6W__content-blocks-renderer__item",
  "content-blocks-renderer__skeleton": "ContentBlocksRenderer-module-scss-module__Kdva6W__content-blocks-renderer__skeleton",
  "shimmer": "ContentBlocksRenderer-module-scss-module__Kdva6W__shimmer",
});
